/*
  Cart total next to the header cart icon (header setting "Show cart total").
  The total comes from the `cart-count` section, so it uses the store's money format.
  - Add to cart: read from the section HTML included in the cart update event.
  - Other changes (cart drawer quantity, remove, refresh): the count badge changes,
    so re-fetch the section and update.
  Hidden, with the pill style removed, whenever the cart is empty.
*/
if (!customElements.get('m-cart-total')) {
  class MCartTotal extends HTMLElement {
    connectedCallback() {
      this.bubble = this.closest('.m-cart-icon-bubble');
      this.count = this.bubble ? this.bubble.querySelector('m-cart-count') : null;

      if (typeof DeliEvents !== 'undefined' && typeof DeliTheme !== 'undefined') {
        this.unsubscribe = DeliEvents.subscribe(DeliTheme.pubSubEvents.cartUpdate, (event) => {
          const cart = event && event.cart;
          const html = cart && !cart.errors && cart.sections && cart.sections['cart-count'];
          if (!html) return;
          this.handledAt = Date.now();
          this.render(new DOMParser().parseFromString(html, 'text/html'));
        });
      }

      if (this.count) {
        this.observer = new MutationObserver(() => this.refresh());
        this.observer.observe(this.count, { childList: true, characterData: true, subtree: true });
      }
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      if (this.observer) this.observer.disconnect();
      clearTimeout(this.timer);
    }

    refresh() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        // Already updated from the cart event payload.
        if (this.handledAt && Date.now() - this.handledAt < 1000) return;
        fetch(`${window.Shopify.routes.root}?section_id=cart-count`)
          .then((response) => response.text())
          .then((html) => this.render(new DOMParser().parseFromString(html, 'text/html')))
          .catch(() => {});
      }, 150);
    }

    render(doc) {
      const value = doc.querySelector('.m-cart-total-value');
      if (!value) return;
      const isEmpty = parseInt(value.dataset.itemCount, 10) === 0;
      this.textContent = isEmpty ? '' : value.textContent.trim();
      this.classList.toggle('m:hidden', isEmpty);
      if (this.bubble) this.bubble.classList.toggle('is-empty', isEmpty);
    }
  }

  customElements.define('m-cart-total', MCartTotal);
}
